export default "__VITE_ASSET__755044f2__"